var React = require('react');

function Helicopter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M61.062 1H2.938a1.936 1.936 0 100 3.875h25.188v3.784c-7.75 0-15.5 6.948-16.042 15.5v15.5c.542 4.625 2.607 8.734 5.816 11.571l-4.888 8.476a2.197 2.197 0 00.802 2.997 2.19 2.19 0 002.997-.794l4.753-8.211c2 .94 4.208 2.303 6.562 2.303h7.749c2.354 0 4.563-1.363 6.562-2.303l4.753 8.211a2.196 2.196 0 003.799-2.203l-4.888-8.476c3.208-2.836 5.274-6.946 5.899-11.571v-15.5c-.625-8.552-8.375-15.5-16.125-15.5V4.875h25.188A1.936 1.936 0 0063 2.937 1.94 1.94 0 0061.062 1zM45 24.159V31H19v-6.841C19 19.883 22.849 15 27.125 15h9.75C41.151 15 45 19.883 45 24.159z"}));
}

Helicopter.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = Helicopter;

Helicopter.default = Helicopter;
